<template>
    <div>
        <div class="card">
            <div class="card__header">
				<h4 class="card__title">AML Policy</h4>
            </div>
            <div class="card__body info-page">
				<h5>For Deposits and Withdrawals</h5>

Introduction: {{ $root.$company.project }} is operated by {{ $root.$company.company }} having its office at {{ $root.$company.address }}, {{ $root.$company.city }}. Company Registration number {{ $root.$company.number }}<br />
<br />
Objective of the AML Policy: We seek to offer the highest security to all of our users and customers on {{ $root.$company.project }} for that a three step account verification is done in order to insure the identity of our customers. The reason behind this is to prove that the details of the person registered are correct and the deposit methods used are not stolen or being used by someone else, which is to create the general framework for the fight against money laundering. We also take into accord that depending on the nationality and origin, the way of payment and for withdrawing different safety measurements must be taken.<br />
<br />
{{ $root.$company.project }} also puts reasonable measures in place to control and limit ML risk, including dedicating the appropriate means.<br />
<br />
{{ $root.$company.project }} is committed to high standards of anti-money laundering (AML) according to the EU guidelines, compliance and requires management & employees to enforce these standards in preventing the use of its services for money laundering purposes.<br />
<br />
The AML program of {{ $root.$company.project }} is designed to be compliant with:<br />
<br />
EU : “Directive 2015/849 of the European Parliament and of The Council of 20 May 2015 on the prevention of the use of the financial system for the purposes of money laundering”<br />
<br />
EU : “Regulation 2015/847 on information accompanying transfers of funds”<br />
<br />
EU : Various regulations imposing sanctions or restrictive measures against persons and embargo on certain goods and technology, including all dual-use goods<br />
<br />
BE : “Law of 18 September 2017 on the prevention of money laundering limitation of the use of cash<br />
<br />
<h5>Definition of money laundering</h5>
Money Laundering is understood as:<br />
<br />
• The conversion or transfer of property, especially money, knowing that such property is derived from criminal activity or from taking part in such activity, for the purpose of concealing or disguising the illegal origin of the property or of helping any person who is involved in the commission of such an activity to evade the legal consequences of that person's or companies action;<br />
• The concealment or disguise of the true nature, source, location, disposition, movement, rights with respect to, or ownership of, property, knowing that such property is derived from criminal activity or from an act of participation in such an activity;<br />
• The acquisition, possession or use of property, knowing, at the time of receipt, that such property was derived from criminal activity or from assisting in such an activity;<br />
• Participation in, association to commit, attempts to commit and aiding, abetting, facilitating and counselling the commission of any of the actions referred to in points before.<br />
<br />
Money laundering shall be regarded as such even when the activities which generated the property to be laundered were carried out in the territory of another Member State or in that of a third country.<br />

<h5>Organization of the AML for {{ $root.$company.project }}</h5>
In accordance with the AML legislation, {{ $root.$company.project }} has appointed the “highest level” for the prevention of ML: The full management of {{ $root.$company.company }} are in charge.<br />
<br />
Furthermore, an AMLCO (Anti Money Laundering Compliance Officer) is in charge of the enforcement of the AML policy and procedures within the System.<br />
<br />
The AMLCO is placed under the direct responsibility of the general Management:<br />
<br />
 
<h5>AML policy changes and implementation requirements</h5>
Each major change of {{ $root.$company.project }} AML policy is subject to be approval by the general management of {{ $root.$company.company }} and the Anti money laundering compliance officer.<br />

<h6>Three step Verification</h6>
<div>Step one verification</div>
Step one verification must be done by every user and customer to withdraw. Regarding of the choice of payment, the amount of payment, the amount of withdraw, the choice of withdraw and nationality of the user/customer step one verification must be done first. Step one verification is a document that must be filled out by the user/customer himself. Following information’s must be filled in: first name, second name, date of birth, country of usual residence, gender and full address.<br />

<div>Step two verification</div>
Step two verification must be done by every user which deposit over 2000 EUR (two thousand Euro) or withdraws any amount. Until step two verification is done the withdraw, tip or deposit will be hold. Step to verification will lead the user or customer to a subpage where he must send in his ID. The user/customer must make a picture of his ID. While a paperclip with a six-digit random generated number is next to his ID: Only an official ID may be used for ID verification, depending on the country the variety of accepted IDs may be different. There will also be an electronic check if the filled in Data from the step one verification is correct. The electronic check will check via two different databanks to insure the given information’s matches with the filled document and the name from the ID: If the electronic test fails or is not possible the user/customer is required to send in a conformation of his current resident. A certificate of registration by the government or a similar document is required.<br />

<div>Step three verification</div>
Step three verification must be done by every user which deposit over 5000$ (five thousand Dollar) or withdraws over 5000$ (five thousand Dollar) or sends another user over 3000$ (three thousand Dollar) Until step three verification is done the withdraw, tip or deposit will be hold. For step 3 a user/customer will be asked for a source of wealth.<br />

 
<h5>Customer identification and verification (KYC)</h5>
The formal identification of customers on entry into commercial relations is a vital element, both for the regulations relating to money laundering and for the KYC policy.
<br /><br />
This identification relies on the following fundamental principles:
<br /><br />
A copy of your passport, ID card or driving license, each shown alongside a handwritten note mentioning six random generated numbers. Also, a second picture with the face of the user/customer is required. The user/customer may blur out every information, besides date of birth, nationality, gender, first name, second name and the picture. To secure their privacy.
<br /><br />
Please note that all four corners of the ID have to be visible in the same image and all details has to be clearly readable besides the named above. We might ask for all details if necessary.
<br /><br />
An employee may do additional checks if necessary, based on the situation.

 
<h5>Proof of Address</h5>
Proof of address will be done via to different electronic checks, which use two different databases. If an electronic test fails, the user/customer has the option to make a manually proof.
<br /><br />
A recent utility bill sent to your registered address, issued within the last 3 months or an official document made by the government that proofs your state of residence.
<br /><br />
To make the approval process as speedy as possible, please make sure the document is sent with a clear resolution where all four corners of the document is visible, and all text is readable.
<br /><br />
For example: An electricity bill, water bill, bank statement or any governmental post addressed to you.
<br /><br />
An employee may do additional checks if necessary, based on the situation.

 
<h5>Source of funds</h5>
If a player deposits over a five thousand euro there is a process of understandings the source of wealth (SOW)
<br /><br />
Examples of SOW are:
<br />
• Ownership of business<br />
• Employment<br />
• Inheritance<br />
• Investment<br />
• Family<br />
<br />
It is critical that the origin and legitimacy of that wealth is clearly understood. If this is not possible an employee may ask for an additional document or prove.
<br /><br />
The account will be frozen if the same user deposits either this amount in one go or multiple transactions which amount to this. An email will be sent to them manually to go through the above and an information on the website itself.
<br /><br />
{{ $root.$company.project }} also asks for a bank wire/credit card to further insure the Identity of the user/customer. It also gives additional information about the financial situation of the user/customer.

 
<h5>Basic document for step one</h5>
The basic document will be accessible via the setting page on {{ $root.$company.project }}. Every user has to fill out the following information’s:
<br /><br />
• First name
• Second name
• Nationality
• Gender
• Date of Birth
<br /><br />
The document will be saved and created by an AI, an employee may do additional checks if necessary based on the situation.
 
<h5>Risk management</h5>
In order to deal with the different risks and different states of wealth in different regions on the earth {{ $root.$company.project }} will categorize every nation in three different regions of risk.
<br /><br />
Region one: Low risk:<br />
For every nation from the region one the three-step verification is done as described earlier.
<br /><br />
Region two: Medium risk:<br />
For every nation from the region two the three-step verification will be done at lower deposit, withdraw and tip amounts. Step one will be done as usually. Step two will be done after depositing 1000$ (one thousand Dollars), withdrawing 1000$ (one thousand Dollars) or tipping another user/customer 500$ (five hundred Dollars.) Step three will be done after depositing 2500$ (two thousand five hundred Dollars), withdrawing 2500$ (two thousand five hundred Dollars) or tipping another user/customer 1000$ (one thousand Dollars). Also, users from a low risk region that change crypto currency in any other currency will be treated like user/customers from a medium risk region.
<br /><br />
Region three: High risk:<br />
Regions of high risks will be banned. High risk regions will be regularly updated to keep up with the changing environment of a fast-changing world.

 
<h5>Additional measurements</h5>
In addition, an AI which is overseen by the AML compliance officer will look for any unusual behaviour and report it right away to a employee of {{ $root.$company.project }}.
<br /><br />
According to a risk based few and general experience the human employees will recheck all checks which are done bevor by the AI or other employees and may redo or do additional checks according to the situation.
<br /><br />
In addition, a data Scientist supported by modern, electronic, analytic systems will look for unusual behaviour like: Depositing and withdrawing without longer Betting sessions. Attempts to use a different Bank account to for Deposit and Withdraw, nationality changes, currency changes, behaviour and activity changes as well as checks, if an account is used by it´s original owner.
<br /><br />
Also a User has to use the same method for Withdraw as he used for Deposit, for the amount of the initial Deposit to prevent any Money Laundering.

<div>Enterprise-wide risk assessment</div>
As part of its risk-based approach, {{ $root.$company.project }} has conducted an AML “Enterprise-wide risk assessment” (EWRA) to identify and understand risks specific to {{ $root.$company.project }} and its business lines. The AML risk policy is determined after identifying and documenting the risks inherent to its business lines such as the services the website offers. The Users to whom services are offered, transactions performed by these Users, delivery channels used by the bank, the geographic locations of the bank’s operations, customers and transactions and other qualitative and emerging risks.
<br /><br />
The identification of AML risk categories is based on {{ $root.$company.project }} understanding of regulatory requirements, regulatory expectations and industry guidance. Additional safety measures are taken to take care of the additional risks the world wide web brings with it.
<br /><br />
The EWRA is yearly reassessed.

<h5>Ongoing transaction monitoring</h5>
AML-Compliance ensures that an “ongoing transaction monitoring” is conducted to detect transactions which are unusual or suspicious compared to the customer profile.<br />
This transaction monitoring is conducted on two levels:
<br />
<div>The first Line of Control</div>

{{ $root.$company.project }} works solely with trusted Payment Service Providers whom all have effective AML policies in place as to prevent the large majority of suspicious deposits onto {{ $root.$company.project }} from taking place without proper execution of KYC procedures onto the potential customer.

<div>The second Line of Control</div>

{{ $root.$company.project }} makes its network aware so that any contact with the customer or player or authorized representative must give rise to the exercise of due diligence on transactions on the account concerned. In particular these include:
<br />
• Requests for the execution of financial transactions on the account;<br />
• Requests in relation to means of payment or services on the account;<br />
<br />
Also, the three-step verification with adjusted risk management should provide all necessary information’s about all costumers of {{ $root.$company.project }} at all time.
<br /><br />
Also, all transaction must be overseen by employees over watched by the AML compliance officer who is over watched by the general management.
<br /><br />
The specific transactions submitted to the customer support manager, possibly through their Compliance Manager must also be subject to due diligence.
<br /><br />
Determination of the unusual nature of one or more transactions essentially depends on a subjective assessment, in relation to the knowledge of the customer (KYC), their financial behaviour and the transaction counterparty.
<br /><br />
These checks will be done by an automated System, while an Employee crosschecks them for additional security.
<br /><br />
The transactions observed on customer accounts for which it is difficult to gain a proper understanding of the lawful activities and origin of funds must therefore rapidly be considered atypical (as they are not directly justifiable).
<br /><br />
Any {{ $root.$company.project }} staff member must inform the AML division of any atypical transactions which they observe and cannot attribute to a lawful activity or source of income known of the customer.
<br />
<div>The third Line of Control</div>

As a last line of defence against AML {{ $root.$company.project }} will do manually checks on all suspicious and higher risk users in order to fully prevent money laundering.
<br /><br />
If fraud or Money Laundering is found the authorities will be informed.

<h5>Reporting of Suspicious transactions on {{ $root.$company.project }}</h5>

In its internal procedures, {{ $root.$company.project }} describes in precise terms, for the attention of its staff members, when it is necessary to report and how to proceed with such reporting.
<br /><br />
Reports of atypical transactions are analysed within the AML team in accordance with the precise methodology fully described in the internal procedures.
<br /><br />
Depending on the result of this examination and on the basis of the information gathered, the AML team:
<br /><br />
• will decide whether it is necessary or not to send a report to the FIU, in accordance with the legal obligations provided in the Law of 18 September 2017;
<br /><br />
• will decide whether or not it is necessary to terminate the business relations with the customer.

<h5>Procedures</h5>
The AML rules, including minimum KYC standards will be translated into operational guidance or procedures that are available on the Intranet site of {{ $root.$company.project }}.

 
<h5>Record keeping</h5>
Records of data obtained for the purpose of identification must be kept for at least ten years after the business relationship has ended.
<br /><br />
Records of all transaction data must be kept for at least ten years following the carrying-out of the transactions or the end of the business relationship.
<br /><br />
These data will be safely, encrypted stored offline and online.

<h5>Auditing</h5>
Internal audit regularly establishes missions and reports about AML activities.<br />

<h5>Data Security</h5>
All data given by any user/customer will be kept secure, will not be sold or given to anyone else. Only if forced by law, or to prevent money laundering data may be shared with the AML-authority of the affected state.<br />
<br />
{{ $root.$company.project }} will follow all guidelines and rules of the data protection directive (officially Directive 95/46/EC)<br />

<h5>Contact us</h5>
If you have any questions about our AML and KYC Policy or if you have any complains about our AML and KYC Policy or about the checks done on your Account and your Person, please contact us: <a :href="'mailto:' + $root.$company.email">{{ $root.$company.email }}</a>

            </div>
        </div>
    </div>
  </template>

<script>
export default {
    data() {
        return { }
    },
    methods: {
    }
}
</script>

<style scoped>

.info-page h5 {
	font-weight: bold;
	margin: 16px 0 8px;
}

.info-page h5:first-child {
	margin-top: 0;
}

.info-page h5:last-child {
	margin-bottom: 0;
}
</style>